<div class="loading-card centered-container">
  <div class="loading-spinner">
    <p-progressSpinner
      styleClass="w-4rem h-4rem"
      strokeWidth="3"
      animationDuration=".8s"
      strokeColor="var(--primary-color)"
    />
  </div>
  <div class="loading-content">
    <h3 class="loading-title">{{ dataService.getTexts().ConsentCallbackLoadingTitle }}</h3>
    <p class="loading-message">
      <span>{{ dataService.getTexts().ConsentCallbackProcessing }}</span>
    </p>
  </div>
</div>